import { render, staticRenderFns } from "./ChatGroupSide.vue?vue&type=template&id=d83e46e2&scoped=true"
import script from "./ChatGroupSide.vue?vue&type=script&lang=js"
export * from "./ChatGroupSide.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupSide.vue?vue&type=style&index=0&id=d83e46e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83e46e2",
  null
  
)

export default component.exports